import Type from '@/pages/typeAdmin/Type.page'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/type-editor')({
  component: () => <TypeLayout />,
})

const TypeLayout = () => {
  return (
    <>
      <Type />
      <Outlet />
    </>
  )
}
